<template>
  <div>
    <v-navigation-drawer
      v-if="$vuetify.breakpoint.lg ? drawer = false : drawer = drawer"
      disable-resize-watcher
      floating
      fixed
      v-model="drawer"
      app
      class="side-bar"
    >
      <v-list-tile class="side-bar-search">
        <v-text-field
          class="min-w max-w"
          v-model="search"
          append-icon="search"
          :label="$lang.labels.search"
          hide-details
        />
      </v-list-tile>
      <v-list dense class="mt-2">
        <v-list-tile
          v-for="(item, index) in filteredLinks"
          :key="index"
          :to="`/${language}${item.path}`">
          <v-list-tile-content>
            <v-list-tile-title>{{$lang.header[item.title]}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="primary" app light class="py-2">
      <v-toolbar-side-icon @click.stop="drawer = !drawer" color="white--text hidden-lg-and-up"/>
      <v-toolbar-title>
        <router-link class="logo px-0 mr-2" :to="{name: 'home'}">
          {{$lang.global.projectName}}
        </router-link>
      </v-toolbar-title>
      <ul class="layout row wrap pl-2 hidden-md-and-down">
        <router-link tag="li" class="px-2" v-for="(item, index) in approvedLinks" :key="index" :to="`/${language}${item.path}`" active-class="active">{{$lang.header[item.title]}}</router-link>
      </ul>
      <v-spacer />
      <div class="d-flex">
        <router-link
          tag="v-btn"
          class="elevation-0 log-out white--text"
          to="/log-out">
          {{$lang.header.logout}}
        </router-link>
      </div>
    </v-toolbar>
    <v-container fluid>
      <router-view />
    </v-container>
  </div>
</template>

<script>
  import { Settings as DateTimeSettings } from 'luxon'
  import blocks from '../router/role-map';

  export default {
    data() {
      return {
        drawer: false,
        search: '',
        menu: [
          {
            path: '/accounts',
            title: 'accounts',
          },
          {
            path: '/app-resources',
            title: 'apps',
          },
          {
            path: '/audit-log',
            title: 'auditLog'
          },
          {
            path: '/auto-jobs',
            title: 'autoJobs',
          },
          {
            path: '/caller-id-servers',
            title: 'callerId',
          },
          {
            path: '/cash-register',
            title: 'cashRegister',
          },
          {
            path: '/catalog',
            title: 'catalogs',
          },
          {
            path: '/companies',
            title: 'companies',
          },
          {
            path: '/config-updates',
            title: 'configUpdates',
          },
          {
            path: '/corporations',
            title: 'corporations',
          },
          {
            path: '/discount',
            title: 'discounts',
          },
          {
            path: '/domain-dashboard',
            title: 'domains',
          },
          {
            path: '/language-mappings',
            title: 'languageMappings',
          },
          {
            path: '/licenses',
            title: 'licenses',
          },
          {
            path: '/license-reports',
            title: 'licenseReports',
          },
          {
            path: '/moon-instance-dashboard',
            title: 'moonInstances',
          },
          {
            path: '/images',
            title: 'images',
          },
          {
            path: '/invoices',
            title: 'pricingInvoices',
          },
          {
            path: '/payment-terminals',
            title: 'paymentTerminals',
          },
          {
            path: '/payment-servers',
            title: 'paymentServers',
          },
          {
            path: '/printers',
            title: 'printers',
          },
          {
            path: '/print-servers',
            title: 'printServers',
          },
          {
            path: '/print-templates',
            title: 'printTemplates',
          },
          {
            path: '/resource-tracking',
            title: 'resourceTracking',
          },
          {
            path: '/tables',
            title: 'tables',
          },
          {
            path: '/table-categories',
            title: 'tableCategories',
          },
          {
            path: '/system-logs',
            title: 'systemlog',
          },
          {
            path: '/web-shop-dashboard',
            title: 'webShops',
          },
          {
            path: '/webshopusage-reports',
            title: 'webshopusageReports',
          },
          {
            path: '/web-space-dashboard',
            title: 'webspace',
          },
        ],
        openLang: false,
        language: this.$cookie.get('lang') || 'en',
      };
    },
    computed: {
      approvedLinks() {
        return this.menu.filter(route => !this.shouldBlock(route.path.slice(1)));
      },
      filteredLinks() {
        return this.search.length === 0 ? this.approvedLinks : this.approvedLinks.filter(link =>
          link.title.toLowerCase().includes(this.search.toLowerCase()));
      },
    },
    methods: {
      shouldBlock(route) {
        const roles = this.$auth.roles;
        const currentGuard = blocks.find(block => block.path === route);
        if (!currentGuard) return false;
        let shouldBlock = true;
        currentGuard.roles.forEach((role) => {
          if (roles.includes(role)) shouldBlock = false;
        });
        return shouldBlock;
      },
      // Set language and add to cookie, then change route
      changeLang(lang) {
        this.language = lang;
        this.$lang.setLang(lang);
        this.$cookie.set('lang', lang, { expires: '8h' });
        this.openLang = !this.openLang;
        this.$router.push({ name: this.$route.name, params: { lang } });
        DateTimeSettings.defaultLocale = lang;
      },
    },
  };
</script>

<style lang="css">
  .v-toolbar__title {
    overflow: visible !important;
    text-overflow: initial !important;
  }
  .v-toolbar--fixed {
    position: relative !important;
  }
</style>

<style lang="scss" scoped>
  a {
    padding: .5rem 1rem;
  }
  p {
    display: inline-block;
  }
  .logo {
    width: auto;
    height: auto;
    font-size: 30px;
    color: #fff;
    text-decoration: none;
    margin: 0;
    padding-bottom: 10px;
    min-width: 150px;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  li {
    font-size: 17px;
    display: inline-block;
    color: #fff;
    opacity: 0.8;
    transition: ease-in 0.2s;
    border-radius: 2px;
    &:hover {
      opacity: 1;
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.09);
    }
  }
  .side-bar {
    padding-top: 16px;
  }
  .side-bar-search {
    background-color: white;
    display: flex;
    position: sticky;
    width: 100%;
    height: auto;
    z-index: 15;
    top: 0;
    padding-bottom: 12px;
  }
  .log-out {
    background-color: transparent !important;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// Layout.vue?64192a72